import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { SocialProof } from "../components/SocialProof";
import { Features } from "../components/Features";
import { Pricing } from "../components/Pricing";
import { X402Section } from "../components/X402Section";
import { Footer } from "../components/Footer";

export function Landing() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Navbar />

      {/* Main content */}
      <main>
        {/* Hero section with code demo */}
        <Hero />

        {/* Social proof / logo cloud */}
        <SocialProof />

        {/* Features grid */}
        <Features />

        {/* Pricing section */}
        <Pricing />

        {/* x402 AI payments section */}
        <X402Section />

        {/* CTA Section */}
        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block p-8 md:p-12 bg-gradient-to-r from-sky-500 to-sky-600 rounded-3xl shadow-xl shadow-sky-200">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                Ready to get started?
              </h2>
              <p className="text-sky-100 mb-8 max-w-md mx-auto">
                Create your free account and get your API key in seconds. No
                credit card required.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="/signup"
                  className="w-full sm:w-auto px-8 py-3 bg-white text-sky-700 font-semibold rounded-xl hover:bg-sky-50 transition-colors shadow-lg"
                >
                  Start for free →
                </a>
                <a
                  href="/docs"
                  className="w-full sm:w-auto px-8 py-3 bg-sky-400/20 text-white font-semibold rounded-xl border border-white/20 hover:bg-sky-400/30 transition-colors"
                >
                  Read the docs
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Landing;
